import { FilteredItem } from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { GetEmspUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.model';

import {
  EMSP_BO_EMSP_USER_LIST_FILTER,
  EMSP_BO_EMSP_USER_LIST_FILTER_NAME_LIST,
} from '../emsp-bo-emsp-user-list/emsp-bo-emsp-user-list.config';
import { useEmspBoEmspUserListContext } from '../emsp-bo-emsp-user.context';
import * as css from './emsp-bo-emsp-user-list-filter-state.module.scss';

export const EmspBoEmspUserListFilterStateController =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
      useEmspBoEmspUserListContext();

    // HANDLERS ////////////////////////////////////////////////////////////////

    const handleRemove = <
      FilterNameKey extends keyof GetEmspUsersPaginatedModel,
    >(
      filterName: FilterNameKey,
      filterValue: GetEmspUsersPaginatedModel[FilterNameKey],
    ): void => {
      setGetPaginatedQueryParameters((current) => {
        const queryParameterValue = current[filterName];

        if (Array.isArray(queryParameterValue) && !Array.isArray(filterValue)) {
          return {
            ...current,
            [filterName]: queryParameterValue.filter(
              (item) => item !== filterValue,
            ),
          };
        }

        return {
          ...current,
          [filterName]: undefined,
        };
      });
    };

    // DATA FETCHING ///////////////////////////////////////////////////////////

    const filterNameActiveList = EMSP_BO_EMSP_USER_LIST_FILTER_NAME_LIST.filter(
      (filterName) => getPaginatedQueryParameters[filterName] !== undefined,
    );

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Stack
        className={css.filtersSection}
        flex={1}
        gap={GapEnum.S}
        justifyContent="space-between"
        alignItems="center">
        <Stack
          direction="row"
          className={css.displayedFiltersSection}
          gap={GapEnum.S}
          alignItems="center"
          flex={1}>
          {filterNameActiveList
            .flatMap((filterName) => {
              const filterValue = getPaginatedQueryParameters[filterName];

              if (filterValue === undefined) {
                return [];
              }

              const FilteredItemComponent =
                EMSP_BO_EMSP_USER_LIST_FILTER[filterName]?.componentType;

              // Case 1: Query parameter is a set of values
              if (Array.isArray(filterValue)) {
                return filterValue.map((filterValueItem) => {
                  if (FilteredItemComponent) {
                    return (
                      <FilteredItemComponent
                        key={`${filterName}-${filterValueItem}`}
                        value={filterValueItem}
                        onRemove={() =>
                          handleRemove(filterName, filterValueItem)
                        }
                      />
                    );
                  }

                  return (
                    <FilteredItem
                      key={`${filterName}-${filterValueItem}`}
                      label={`${filterValueItem}`}
                      onRemove={() => handleRemove(filterName, filterValueItem)}
                    />
                  );
                });
              }

              // Case 2: Query parameter is a unique value
              if (FilteredItemComponent) {
                return [
                  <FilteredItemComponent
                    key={filterName}
                    value={filterValue}
                    onRemove={() => handleRemove(filterName, filterValue)}
                  />,
                ];
              }

              return [
                <FilteredItem
                  key={filterName}
                  label={`${filterValue}`}
                  onRemove={() => handleRemove(filterName, filterValue)}
                />,
              ];
            })
            .slice(0, 3)}
        </Stack>
      </Stack>
    );
  };
